<template>
  <div>
    <ul class="status-list">
      <li>{{ $t("supplier.suppliers") }} {{ suppliers.length }}</li>
      <li>
        <button
          @click="$emit('select', 'new')"
          class="btn btn-text text-text-info-dark"
        >
          {{ $t("supplier.new") }} {{ supplierStatuses.new }}
        </button>
      </li>
      <li>
        <button
          @click="$emit('select', 'pending')"
          class="btn btn-text text-danger"
        >
          {{ $t("supplier.pending") }} {{ supplierStatuses.pending }}
        </button>
      </li>
      <li>
        <button
          @click="$emit('select', 'error')"
          class="btn btn-text text-error"
        >
          {{ $t("supplier.error") }} {{ supplierStatuses.error }}
        </button>
      </li>
      <li>
        <button
          @click="$emit('select', 'active')"
          class="btn btn-text text-success"
        >
          {{ $t("supplier.active") }} {{ supplierStatuses.active }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["suppliers", "supplierStatuses"]
};
</script>

<style scoped>
.btn-text:hover {
  text-decoration: underline;
}
.status-list {
  font-size: 20px;
  list-style: none;
}
.btn-text {
  font-size: 20px;
}
</style>
